<div class="pc-page-shell">
  <div class="filter-container" [class.open]="isFilterOpen">

    <div class="filter-panel" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">

      <!-- HEADER -->
      <div class="filter-header">

        <div class="header-left">
          <mat-icon>filter_alt</mat-icon>
          <span>Table Filter</span>
        </div>

        <mat-icon class="close-btn" (click)="isFilterOpen = false">
          close
        </mat-icon>

      </div>

      <!-- BODY -->
      <form [formGroup]="filterForm" class="filter-body">

        <div class="filter-grid">
          <!-- 1. CLIENT STATUS (multi: Active + Inactive, with Select All) -->
          <div class="filter-item full-width" *ngIf="subusername !== 'demo'">
            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
              Client Status
            </label>

            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="" placeholder="Select Client Status"
              allLabel="All" [options]="clientStatusOptions" [selected]="selectedClientStatuses"
              (selectedChange)="onClientStatusesChanged($event)">
            </app-pc-multi-select-filter>
          </div>

          <!-- 2. CLIENT -->
          <div class="filter-item full-width" *ngIf="(username === 'Meraki - Operations' && subusername !== 'demo')"
            [class.filter-field-disabled]="isClientFieldBlocked()">

            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
              Client
              <mat-spinner *ngIf="isLoadingFilterOptions && isClientFilterEnabled()" diameter="16"
                class="filter-inline-spinner">
              </mat-spinner>
            </label>

            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="" placeholder="Select Client" allLabel="All"
              [options]="apiClientOptions" [selected]="selectedClients" (selectedChange)="onClientsChanged($event)">
            </app-pc-multi-select-filter>

          </div>

          <!-- 3. SEGMENT (multi-select, same UX as Client) -->
          <div class="filter-item full-width">
            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
              Segment
            </label>

            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="" placeholder="Select Segment" allLabel="All"
              [options]="segmentMultiSelectOptions" [selected]="selectedSegments"
              (selectedChange)="onSegmentsChanged($event)">
            </app-pc-multi-select-filter>
          </div>

          <!-- 4. SHIP NAME -->
          <div class="filter-item full-width" [class.filter-field-disabled]="isDownstreamFieldBlocked()">

            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
              Ship Name
              <mat-spinner *ngIf="isLoadingClientFilterOptions && hasClientSelected()" diameter="16"
                class="filter-inline-spinner">
              </mat-spinner>
            </label>

            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="" placeholder="Select Ship Name"
              allLabel="All" [options]="shipFilterOptions" [selected]="selectedShips"
              (selectedChange)="onVesselsChanged($event)">
            </app-pc-multi-select-filter>

          </div>

          <!-- 5. PORT -->
          <div class="filter-item full-width" [class.filter-field-disabled]="isDownstreamFieldBlocked()">

            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
              Port:
            </label>

            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="" placeholder="Select Port" allLabel="All"
              [options]="portFilterOptions" [selected]="selectedFilterPort" (selectedChange)="onPortsChanged($event)">
            </app-pc-multi-select-filter>

          </div>

          <!-- 7. OPERATIONS -->
          <div class="filter-item full-width" [class.filter-field-disabled]="isDownstreamFieldBlocked()">

            <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
              Operations:
            </label>

            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="" placeholder="Select Operation"
              allLabel="All" [options]="operationFilterOptions" [selected]="selectedOperations"
              (selectedChange)="onOperationsChanged($event)">
            </app-pc-multi-select-filter>

          </div>

          <!-- DATE FILTERS -->
          <div class="filter-item full-width">

            <app-custom-date-picker [label]="'From Date:'" [controlname]="filterForm.controls['from_date']">
            </app-custom-date-picker>

          </div>

          <div class="filter-item full-width">

            <app-custom-date-picker [label]="'To Date:'" [controlname]="filterForm.controls['to_date']">
            </app-custom-date-picker>

          </div>
          <div class="ilter-item full-width">
            <app-custom-dropdown [label]="'Over Consumption:'" [items]="overConsumptionOptions"
              [controlname]="this.filterForm.controls['overConsumption']"></app-custom-dropdown>
          </div>

          <!-- CP OVERALL RANGE -->
          <div class="filter-item full-width pd-overall-range-filter">

            <div class="pd-overall-range-filter__label-row">
              <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
                CP Overall Range
              </label>
              <mat-icon class="pd-overall-range-filter__info" [matTooltip]="cpOverallRangeTooltip"
                matTooltipPosition="above">
                info_outline
              </mat-icon>
            </div>

            <ng-container *ngIf="hasCpOverallRangeData(); else cpOverallRangeUnavailable">
              <div class="pd-overall-range-filter__row">
                <span class="pd-overall-range-filter__endpoint"
                  [ngClass]="getOverallRangeEndpointClass(minCpOverallSliderVal)">
                  [{{ formatOverallRangeDisplay(minCpOverallSliderVal) }}]
                </span>

                <div class="pd-overall-range-filter__slider-wrap"
                  [style.--pd-range-zero.%]="getCpOverallZeroPosition()">
                  <div class="pd-overall-range-filter__track-bg"></div>
                  <div class="pd-overall-range-filter__zero-marker"></div>
                  <mat-slider class="pd-overall-range-filter__slider" [min]="cpOverallSliderBounds!.min"
                    [max]="cpOverallSliderBounds!.max" [step]="cpOverallRangeStep" [discrete]="true"
                    [showTickMarks]="false">
                    <input matSliderStartThumb [value]="minCpOverallSliderVal!"
                      (valueChange)="onCpOverallSliderChange('min', $event)" />
                    <input matSliderEndThumb [value]="maxCpOverallSliderVal!"
                      (valueChange)="onCpOverallSliderChange('max', $event)" />
                  </mat-slider>
                </div>

                <span class="pd-overall-range-filter__endpoint"
                  [ngClass]="getOverallRangeEndpointClass(maxCpOverallSliderVal)">
                  [{{ formatOverallRangeDisplay(maxCpOverallSliderVal) }}]
                </span>
              </div>

              <div class="pd-overall-range-filter__inputs">
                <div class="pd-overall-range-filter__input-group">
                  <label>MIN VALUE</label>
                  <input type="number" class="pd-overall-range-filter__number-input"
                    [ngClass]="{ 'pd-overall-range-filter__number-input--invalid': !!getCpOverallError('min') }"
                    formControlName="minCpOverall" [step]="cpOverallRangeStep" (blur)="onCpOverallRangeInputBlur()" />
                  <span *ngIf="getCpOverallError('min')" class="pd-overall-range-filter__error">
                    {{ getCpOverallError('min') }}
                  </span>
                </div>
                <span class="pd-overall-range-filter__divider">|</span>
                <div class="pd-overall-range-filter__input-group">
                  <label>MAX VALUE</label>
                  <input type="number" class="pd-overall-range-filter__number-input"
                    [ngClass]="{ 'pd-overall-range-filter__number-input--invalid': !!getCpOverallError('max') }"
                    formControlName="maxCpOverall" [step]="cpOverallRangeStep" (blur)="onCpOverallRangeInputBlur()" />
                  <span *ngIf="getCpOverallError('max')" class="pd-overall-range-filter__error">
                    {{ getCpOverallError('max') }}
                  </span>
                </div>
              </div>

            </ng-container>

            <ng-template #cpOverallRangeUnavailable>
              <p class="pd-overall-range-filter__empty">No range data available</p>
            </ng-template>

          </div>

          <!-- 11. DESIGN OVERALL RANGE -->
          <div class="filter-item full-width pd-overall-range-filter">

            <div class="pd-overall-range-filter__label-row">
              <label class="shipNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
                Design Overall Range
              </label>
              <mat-icon class="pd-overall-range-filter__info" [matTooltip]="designOverallRangeTooltip"
                matTooltipPosition="above">
                info_outline
              </mat-icon>
            </div>

            <ng-container *ngIf="hasDesignOverallRangeData(); else designOverallRangeUnavailable">
              <div class="pd-overall-range-filter__row">
                <span class="pd-overall-range-filter__endpoint"
                  [ngClass]="getOverallRangeEndpointClass(minDesignOverallSliderVal)">
                  [{{ formatOverallRangeDisplay(minDesignOverallSliderVal) }}]
                </span>

                <div class="pd-overall-range-filter__slider-wrap"
                  [style.--pd-range-zero.%]="getDesignOverallZeroPosition()">
                  <div class="pd-overall-range-filter__track-bg"></div>
                  <div class="pd-overall-range-filter__zero-marker"></div>
                  <mat-slider class="pd-overall-range-filter__slider" [min]="designOverallSliderBounds!.min"
                    [max]="designOverallSliderBounds!.max" [step]="designOverallRangeStep" [discrete]="true"
                    [showTickMarks]="false">
                    <input matSliderStartThumb [value]="minDesignOverallSliderVal!"
                      (valueChange)="onDesignOverallSliderChange('min', $event)" />
                    <input matSliderEndThumb [value]="maxDesignOverallSliderVal!"
                      (valueChange)="onDesignOverallSliderChange('max', $event)" />
                  </mat-slider>
                </div>

                <span class="pd-overall-range-filter__endpoint"
                  [ngClass]="getOverallRangeEndpointClass(maxDesignOverallSliderVal)">
                  [{{ formatOverallRangeDisplay(maxDesignOverallSliderVal) }}]
                </span>
              </div>

              <div class="pd-overall-range-filter__inputs">
                <div class="pd-overall-range-filter__input-group">
                  <label>MIN VALUE</label>
                  <input type="number" class="pd-overall-range-filter__number-input"
                    [ngClass]="{ 'pd-overall-range-filter__number-input--invalid': !!getDesignOverallError('min') }"
                    formControlName="minDesignOverall" [step]="designOverallRangeStep"
                    (blur)="onDesignOverallRangeInputBlur()" />
                  <span *ngIf="getDesignOverallError('min')" class="pd-overall-range-filter__error">
                    {{ getDesignOverallError('min') }}
                  </span>
                </div>
                <span class="pd-overall-range-filter__divider">|</span>
                <div class="pd-overall-range-filter__input-group">
                  <label>MAX VALUE</label>
                  <input type="number" class="pd-overall-range-filter__number-input"
                    [ngClass]="{ 'pd-overall-range-filter__number-input--invalid': !!getDesignOverallError('max') }"
                    formControlName="maxDesignOverall" [step]="designOverallRangeStep"
                    (blur)="onDesignOverallRangeInputBlur()" />
                  <span *ngIf="getDesignOverallError('max')" class="pd-overall-range-filter__error">
                    {{ getDesignOverallError('max') }}
                  </span>
                </div>
              </div>
            </ng-container>

            <ng-template #designOverallRangeUnavailable>
              <p class="pd-overall-range-filter__empty">No range data available</p>
            </ng-template>

          </div>

        </div>

      </form>

      <!-- FOOTER -->
      <div class="filter-footer">

        <button class="btn clear-btn" (click)="clearClick()">

          <mat-icon>
            clear_all
          </mat-icon>

          Clear Filter

        </button>

        <button class="btn apply-btn" (click)="filterClick()">

          <mat-icon>
            filter_list
          </mat-icon>

          Apply Filter

        </button>

      </div>

    </div>

  </div>

  <div class="container" [class.container--graph]="graph">
    <div class="statistics-container" #statisticsContainer *ngIf="!isLoadingDatabase">
      <mat-card class="stat-card total-vessels">
        <mat-card-title>Total Port Calls</mat-card-title>
        <mat-card-content>
          <h2>{{ totalVoyages | number : '1.0-0' }}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card total-days">
        <mat-card-title>Total Days</mat-card-title>
        <mat-card-content>
          <h2>{{ totalDays | number : '1.0-0' }}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card total-actual-consumption">
        <mat-card-title>Total Actual Consumption (MT)</mat-card-title>
        <mat-card-content>
          <h2>{{ totalActualConsumption | number : '1.0-0' }}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card total-design-overall" [ngClass]="{
        positive: totalDesignOverall > 0,
        negative: totalDesignOverall < 0
      }">
        <mat-card-title>Total Design Overall</mat-card-title>
        <mat-card-content>
          <h2>{{ totalDesignOverall | number : '1.0-0' }}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card total-cp-consumption">
        <mat-card-title>Total CP Consumption (MT)</mat-card-title>
        <mat-card-content>
          <h2>{{ totalCPConsumption | number : '1.0-0' }}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card stat-card--cp-overall" [ngClass]="{
        positive: totalCpOverallMt > 0,
        negative: totalCpOverallMt < 0
      }">
        <mat-card-title>CP Overall</mat-card-title>
        <mat-card-content>
          <h2>{{ formatCpOverallPercentDisplay() }}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card total-design-consumption">
        <mat-card-title>Total Design Consumption (MT)</mat-card-title>
        <mat-card-content>
          <h2>{{ designConsumptionGroupTotalMt | number: '1.0-0' }}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card stat-card--design-overall" [ngClass]="{
        positive: totalDesignOverall > 0,
        negative: totalDesignOverall < 0
      }">
        <mat-card-title>Design Consumption Overall (%)</mat-card-title>
        <mat-card-content>
          <h2>{{ formatDesignOverallPercentDisplay() }}</h2>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="statistics-container statistics-container--loading" *ngIf="isLoadingDatabase">
      <mat-card class="stat-card stat-card--skeleton" *ngFor="let _ of [1,2,3,4,5,6,7,8]">
        <mat-card-title>&nbsp;</mat-card-title>
        <mat-card-content>
          <h2>—</h2>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="pc-database-toolbar">
      <div class="toggle" [class.toggle--graph]="graph" *ngIf="!hideToggle">
        <mat-slide-toggle [checked]="graph" (change)="toggleMapView($event)">
          {{ graph ? "Table View" : "Graphical Representation" }}
        </mat-slide-toggle>
      </div>
      <mat-icon class="filter-top-btn" (click)="isFilterOpen = true" matTooltip="Table Filter">
        filter_list
      </mat-icon>
    </div>

    <div class="pc-performance-table-stack pc-database-table-stack" *ngIf="!graph">
      <div class="table-view-banner view-active">
        <mat-icon>storage</mat-icon>
        <div class="banner-copy">
          <span class="banner-title">Port Consumption Database</span>
        </div>
        <span class="banner-count">{{ filteredData?.length || 0 }} records</span>
        <button type="button" class="details-universal-toggle" (click)="toggleAllDetailSections($event)"
          [attr.aria-expanded]="allDetailSectionsExpanded"
          [attr.aria-label]="allDetailSectionsExpanded ? 'Collapse all detail sections' : 'Expand all detail sections'">
          <mat-icon>{{ allDetailSectionsExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
          <span>{{ allDetailSectionsExpanded ? 'Collapse all' : 'Expand all' }}</span>
        </button>
      </div>
      <div class="detail-rail-table-wrapper pc-database-table-wrapper" *ngIf="!graph">
        <div class="detail-rail-table-scroll table-container pc-database-table-scroll scroll-bar">
          <table class="pc-database-table detail-rail-table" id="style-4" matSort
            [ngClass]="{ 'dark-table': isDarkMode() }"
            [style.--pd-detail-rail-header-offset.px]="detailRailHeaderOffsetPx"
            [style.--pd-sticky-header-height.px]="mainHeaderStickyHeightPx">
            <thead class="sticky-header">
              <tr class="header-main-row">
                <th [attr.rowspan]="headerRowSpan" class="centersno" mat-sort-header="sNo">S.No</th>
                <th class="fixed-head th-text-center3" [attr.rowspan]="headerRowSpan" mat-sort-header="vessel_name">
                  Vessel Name</th>
                <th [attr.rowspan]="headerRowSpan" class="th-text-center3" mat-sort-header="vessel_imo">Vessel IMO</th>
                <th [attr.rowspan]="headerRowSpan" class="th-text-center3" mat-sort-header="voyage_number">Voyage Number
                </th>
                <th [attr.rowspan]="headerRowSpan" *ngIf="username === 'Meraki - Operations' && subusername !== 'demo'"
                  mat-sort-header="client">Client</th>
                <th [attr.rowspan]="headerRowSpan" class="th-text-center3" mat-sort-header="port">Port</th>
                <th [attr.rowspan]="headerRowSpan" class="th-text-center3" mat-sort-header="segment">Segment</th>

                <ng-container *ngIf="voyageDetailsSectionExpanded">
                  <th [attr.rowspan]="headerRowSpan" class="th-text-center3" mat-sort-header="pic">PIC</th>
                  <th [attr.rowspan]="headerRowSpan" class="th-text-center3" mat-sort-header="final_status">Final Status
                  </th>
                  <th [attr.rowspan]="headerRowSpan" class="th-text-center3" mat-sort-header="operations">Operations
                  </th>
                  <th [attr.rowspan]="headerRowSpan" class="th-text-center1" mat-sort-header="report_sent_date">Report
                    Sent Date (UTC)</th>
                </ng-container>

                <th [attr.rowspan]="headerRowSpan" class="th-text-center1" mat-sort-header="arrival_date_and_time">
                  Arrival Date & Time(UTC)</th>
                <th [attr.rowspan]="headerRowSpan" mat-sort-header="departure_date_and_time" class="th-text-center1">
                  Departure Date & Time(UTC)</th>
                <th [attr.rowspan]="headerRowSpan" class="th-text-center3" mat-sort-header="cargo_quentity">Cargo
                  Quantity (m³)</th>
                <th [attr.rowspan]="headerRowSpan" class="th-text-center3 pd-summary-col" mat-sort-header="total_time">
                  <div class="pd-total-consumption-header">
                    <span>{{ getTotalTimeDaysHeader() }}</span>
                    <span class="pd-total-consumption-header__sum">
                      {{ totalDays | number: '1.0-0' }}
                    </span>
                  </div>
                </th>
                <th [attr.rowspan]="headerRowSpan" class="th-text-center3 pd-maneuvering-col"
                  mat-sort-header="maneuvering_distance">
                  <div class="pd-maneuvering-header">
                    <span>Maneuvering</span>
                    <span>Performance</span>
                    <mat-icon class="pc-col-header__info"
                      matTooltip="Blue = Maneuvering Distance (NM)&#10;Green = Maneuvering Speed (kn)"
                      [matTooltipClass]="databaseTooltipClass">info</mat-icon>
                  </div>
                </th>

                <!-- Ops Data — always visible fixed columns after Total Time -->
                <th colspan="3" class="th-text-center3 pd-group-header pd-group-divider pd-section-title"
                  mat-sort-header="actualconsumption1" arrowPosition="after">
                  <div class="pd-total-consumption-header">
                    <span>Actual Consumption (MT) <mat-icon class="pc-info-icon"
                        matTooltip="Sum of actual leg-wise consumption">info</mat-icon></span>
                    <span class="pd-total-consumption-header__sum"
                      [ngStyle]="{ color: getColor(actualConsumptionGroupTotalMt) }">
                      {{ actualConsumptionGroupTotalMt | number: '1.0-0' }}
                    </span>
                    <!-- <span class="pd-total-consumption-header__percent">
                {{ formatConsumptionGroupSharePercent(actualConsumptionGroupTotalMt) }}
              </span> -->
                  </div>
                </th>
                <th colspan="3" class="th-text-center3 pd-group-header pd-group-divider pd-section-title"
                  mat-sort-header="cpwaranted1" arrowPosition="after">
                  <div class="pd-total-consumption-header">
                    <span>C/P Warranted Consumption (MT)</span>
                    <span class="pd-total-consumption-header__sum"
                      [ngStyle]="{ color: getColor(warrantedConsumptionGroupTotalMt) }">
                      {{ warrantedConsumptionGroupTotalMt | number: '1.0-0' }}
                    </span>
                    <span class="pd-total-consumption-header__percent">
                      {{ formatConsumptionGroupSharePercent() }}<mat-icon class="pc-info-icon"
                        matTooltip="(C/P Warranted Consumption - Actual Consumption) / Actual Consumption">info</mat-icon>
                    </span>
                  </div>
                </th>
                <th colspan="3" class="th-text-center3 pd-group-header pd-group-divider pd-section-title"
                  mat-sort-header="deignconsumption" arrowPosition="after">
                  <div class="pd-total-consumption-header">
                    <span>Design Consumption (MT)</span>
                    <span class="pd-total-consumption-header__sum"
                      [ngStyle]="{ color: getColor(designConsumptionGroupTotalMt) }">
                      {{ designConsumptionGroupTotalMt | number: '1.0-0' }}
                    </span>
                    <span class="pd-total-consumption-header__percent">
                      {{ formatDesignGroupSharePercent() }}<mat-icon class="pc-info-icon"
                        matTooltip="(Design Consumption - Actual Consumption) / Actual Consumption">info</mat-icon>
                    </span>
                  </div>
                </th>
                <th colspan="3" class="th-text-center3 pd-group-header pd-group-divider pd-section-title"
                  mat-sort-header="optimizationConsumption" arrowPosition="after">
                  <div class="pd-total-consumption-header">
                    <span>Optimization Consumption</span>
                    <span class="pd-total-consumption-header__sum"
                      [ngStyle]="{ color: getColor(optimizationConsumptionGroupTotalMt) }">
                      {{ optimizationConsumptionGroupTotalMt | number: '1.0-0' }}
                    </span>
                    <span class="pd-total-consumption-header__percent">
                      {{ formatOptimizationGroupSharePercent() }}<mat-icon class="pc-info-icon"
                        matTooltip="(Optimization Consumption - Actual Consumption) / Actual Consumption">info</mat-icon>
                    </span>
                  </div>
                </th>
                <th colspan="3" class="th-text-center3 pd-group-header pd-group-divider pd-section-title"
                  mat-sort-header="eventTime" arrowPosition="after">
                  <div class="pd-total-consumption-header">
                    <span>Event Time(days)</span>
                    <span class="pd-total-consumption-header__sum" [ngStyle]="{ color: getColor(totalEventTimeDays) }">
                      {{ totalEventTimeDays | number: '1.0-0' }}
                    </span>
                    <span class="pd-total-consumption-header__percent">
                      {{ formatEventTimeSharePercent(totalEventTimeDays) }}
                    </span>
                  </div>
                </th>

                <th [attr.rowspan]="headerRowSpan" class="th-text-center3 pd-summary-col"
                  mat-sort-header="totalconsumption">
                  <div class="pd-total-consumption-header">
                    <span>Total Cons.</span>
                    <span class="pd-total-consumption-header__sum"
                      [ngStyle]="{ color: getColor(totalConsumptionColumnSumMt) }">
                      {{ totalConsumptionColumnSumMt | number: '1.0-0' }}
                    </span>
                  </div>
                </th>

                <ng-container *ngIf="cpExpanded">
                  <th colspan="3" class="th-text-center3 pd-group-header pd-group-divider">C/P Warranted Consumptions
                  </th>
                  <th colspan="3" class="th-text-center2 pd-group-header pd-group-divider">C/P Loss or Gain</th>
                  <th [attr.rowspan]="headerRowSpan" class="th-text-center2 pd-summary-col"
                    mat-sort-header="cp_overall_mt">C/P Overall</th>
                </ng-container>

                <ng-container *ngIf="designExpanded">
                  <th colspan="3" class="th-text-center3 pd-group-header pd-group-divider">Technical Design Consumption
                    (MT)</th>
                  <th colspan="3" class="th-text-center3 pd-group-header pd-group-divider">Technical Loss or Gain</th>
                  <th [attr.rowspan]="headerRowSpan" class="th-text-center2 pd-summary-col"
                    mat-sort-header="design_overall_mt">Design Overall</th>
                </ng-container>

                <ng-container *ngIf="brobSectionExpanded">
                  <th colspan="3" class="th-text-center2 pd-group-header pd-group-divider pd-section-title"
                    mat-sort-header="brobArrival" arrowPosition="after">BROB Arrival (MT)</th>
                  <th colspan="3" class="th-text-center2 pd-group-header pd-group-divider pd-section-title"
                    mat-sort-header="bunkerreceived" arrowPosition="after">Bunker Received</th>
                  <th colspan="3" class="th-text-center2 pd-group-header pd-group-divider pd-section-title"
                    mat-sort-header="brobdeparture" arrowPosition="after">BROB Departure (MT)</th>
                </ng-container>

                <ng-container *ngIf="consumptionSectionExpanded">
                  <th [attr.rowspan]="headerRowSpan"
                    class="th-text-center3 pd-summary-col pd-claim-raised-col pd-group-divider"
                    mat-sort-header="claimRaised">
                    Claim Raised
                  </th>
                  <th colspan="3" class="th-text-center2 pd-group-header pd-group-divider"
                    mat-sort-header="actualconsumption" arrowPosition="after">Actual Consumption (MT)</th>
                </ng-container>

                <!-- Collapse rails — all grouped at extreme right -->
                <ng-container *ngFor="let rail of detailRailSections; let first = first">
                  <th class="detail-rail-header detail-rail-header--{{ rail.cssClass }}"
                    [class.detail-rail-header--collapsed]="!isDetailRailExpanded(rail.key)"
                    [class.detail-rail-header--rail-group-start]="first" rowspan="1">
                    <button type="button" class="detail-rail-band-btn"
                      [class.detail-rail-band-btn--expanded]="isDetailRailExpanded(rail.key)"
                      (click)="toggleDetailRail(rail.key, $event)" [attr.aria-expanded]="isDetailRailExpanded(rail.key)"
                      [attr.aria-label]="(isDetailRailExpanded(rail.key) ? 'Collapse ' : 'Expand ') + rail.fullTitle + ' columns'"
                      [attr.title]="rail.fullTitle">
                      <mat-icon class="detail-rail-toggle-icon">expand_more</mat-icon>
                      <span class="detail-rail-title-compact">
                        <span class="detail-rail-title-line">{{ rail.line1 }}</span>
                        <span class="detail-rail-title-line">{{ rail.line2 }}</span>
                      </span>
                    </button>
                  </th>
                </ng-container>

                <th [attr.rowspan]="headerRowSpan" class="th-text-center3 pd-action-col pd-group-divider"
                  *ngIf="isAdminUser()">
                  Action
                </th>
              </tr>

              <tr *ngIf="showSubHeaderRow" class="port-subheader-row">
                <!-- Ops Data sub-headers — always visible, aligned under Ops group headers after Total Time -->
                <th class="pd-sub-header pd-op-col pd-group-divider pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Maneuvering</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(actualOpSums.maneuvering) }">
                      {{ actualOpSums.maneuvering | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(actualOpSums.maneuvering, actualConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Cargo ops</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(actualOpSums.cargoOps) }">
                      {{ actualOpSums.cargoOps | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(actualOpSums.cargoOps, actualConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Idle</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(actualOpSums.idle) }">
                      {{ actualOpSums.idle | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(actualOpSums.idle, actualConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>

                <th class="pd-sub-header pd-op-col pd-group-divider pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Maneuvering</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(warrantedOpSums.maneuvering) }">
                      {{ warrantedOpSums.maneuvering | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(warrantedOpSums.maneuvering, warrantedConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Cargo ops</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(warrantedOpSums.cargoOps) }">
                      {{ warrantedOpSums.cargoOps | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(warrantedOpSums.cargoOps, warrantedConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Idle</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(warrantedOpSums.idle) }">
                      {{ warrantedOpSums.idle | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(warrantedOpSums.idle, warrantedConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>

                <th class="pd-sub-header pd-op-col pd-group-divider pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Maneuvering</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(designOpSums.maneuvering) }">
                      {{ designOpSums.maneuvering | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(designOpSums.maneuvering, designConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Cargo ops</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(designOpSums.cargoOps) }">
                      {{ designOpSums.cargoOps | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(designOpSums.cargoOps, designConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Idle</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(designOpSums.idle) }">
                      {{ designOpSums.idle | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(designOpSums.idle, designConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>

                <th class="pd-sub-header pd-op-col pd-group-divider pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Maneuvering</span>
                    <span class="pc-op-header__remaining"
                      [ngStyle]="{ color: getColor(optimizationOpSums.maneuvering) }">
                      {{ optimizationOpSums.maneuvering | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(optimizationOpSums.maneuvering, optimizationConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Cargo ops</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(optimizationOpSums.cargoOps) }">
                      {{ optimizationOpSums.cargoOps | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(optimizationOpSums.cargoOps, optimizationConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Idle</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(optimizationOpSums.idle) }">
                      {{ optimizationOpSums.idle | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatOpSharePercent(optimizationOpSums.idle, optimizationConsumptionGroupTotalMt) }}
                    </span>
                  </div>
                </th>

                <th class="pd-sub-header pd-op-col pd-group-divider pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Maneuvering</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(eventTimeSums.maneuvering) }">
                      {{ eventTimeSums.maneuvering | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatEventTimeSharePercent(eventTimeSums.maneuvering) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Cargo ops</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(eventTimeSums.cargoOps) }">
                      {{ eventTimeSums.cargoOps | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatEventTimeSharePercent(eventTimeSums.cargoOps) }}
                    </span>
                  </div>
                </th>
                <th class="pd-sub-header pd-op-col pc-op-header-cell">
                  <div class="pc-op-header">
                    <span class="pc-op-header__name">Idle</span>
                    <span class="pc-op-header__remaining" [ngStyle]="{ color: getColor(eventTimeSums.idle) }">
                      {{ eventTimeSums.idle | number: '1.0-0' }}
                    </span>
                    <span class="pc-op-header__remaining pc-op-header__percent">
                      {{ formatEventTimeSharePercent(eventTimeSums.idle) }}
                    </span>
                  </div>
                </th>

                <ng-container *ngIf="cpExpanded">
                  <th class="pd-sub-header pd-fuel-col" *ngFor="let col of cpOverallDetailColumns"
                    [class.pd-group-divider]="isCpOverallDividerColumn(col.key)">{{ col.label }}</th>
                </ng-container>

                <ng-container *ngIf="designExpanded">
                  <th class="pd-sub-header pd-fuel-col" *ngFor="let col of designOverallDetailColumns"
                    [class.pd-group-divider]="isDesignOverallDividerColumn(col.key)">{{ col.label }}</th>
                </ng-container>

                <ng-container *ngIf="brobSectionExpanded">
                  <th class="pd-sub-header pd-fuel-col pd-group-divider">HSFO</th>
                  <th class="pd-sub-header pd-fuel-col">VLSFO</th>
                  <th class="pd-sub-header pd-fuel-col">LSMGO</th>
                  <th class="pd-sub-header pd-fuel-col pd-group-divider">HSFO</th>
                  <th class="pd-sub-header pd-fuel-col">VLSFO</th>
                  <th class="pd-sub-header pd-fuel-col">LSMGO</th>
                  <th class="pd-sub-header pd-fuel-col pd-group-divider">HSFO</th>
                  <th class="pd-sub-header pd-fuel-col">VLSFO</th>
                  <th class="pd-sub-header pd-fuel-col">LSMGO</th>
                </ng-container>

                <ng-container *ngIf="consumptionSectionExpanded">
                  <th class="pd-sub-header pd-fuel-col pd-group-divider">HSFO</th>
                  <th class="pd-sub-header pd-fuel-col">VLSFO</th>
                  <th class="pd-sub-header pd-fuel-col">LSMGO</th>
                </ng-container>

                <ng-container *ngIf="showSubHeaderRow">
                  <th *ngFor="let rail of detailRailSections"
                    class="detail-rail-header detail-rail-header--spacer detail-rail-header--{{ rail.cssClass }}"
                    aria-hidden="true"></th>
                </ng-container>
              </tr>
            </thead>
            <tbody *ngIf="isLoadingTable">
  <tr *ngFor="let dummy of [1,2,3,4,5,6,7,8,9,10]" class="skeleton-row">
    <td class="centersno"><div class="skeleton-bar sno-skeleton"></div></td>
    <td class="fixed-col"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td *ngIf="username === 'Meraki - Operations' && subusername !== 'demo'"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <ng-container *ngIf="voyageDetailsSectionExpanded">
      <td><div class="skeleton-bar"></div></td>
      <td><div class="skeleton-bar"></div></td>
      <td><div class="skeleton-bar"></div></td>
      <td><div class="skeleton-bar"></div></td>
    </ng-container>

    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td class="pd-maneuvering-col"><div class="skeleton-bar"></div></td>

    <!-- Ops Data Columns -->
    <td class="pd-group-divider"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <td class="pd-group-divider"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <td class="pd-group-divider"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <td class="pd-group-divider"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <td class="pd-group-divider"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <td class="pd-summary-col"><div class="skeleton-bar"></div></td>

    <ng-container *ngIf="cpExpanded">
      <td *ngFor="let col of cpOverallDetailColumns"><div class="skeleton-bar"></div></td>
      <td class="pd-summary-col"><div class="skeleton-bar"></div></td>
    </ng-container>

    <ng-container *ngIf="designExpanded">
      <td *ngFor="let col of designOverallDetailColumns"><div class="skeleton-bar"></div></td>
      <td class="pd-summary-col"><div class="skeleton-bar"></div></td>
    </ng-container>

    <ng-container *ngIf="brobSectionExpanded">
      <td *ngFor="let _ of [1,2,3,4,5,6,7,8,9]"><div class="skeleton-bar"></div></td>
    </ng-container>

    <ng-container *ngIf="consumptionSectionExpanded">
      <td><div class="skeleton-bar"></div></td>
      <td *ngFor="let _ of [1,2,3]"><div class="skeleton-bar"></div></td>
    </ng-container>

    <ng-container *ngFor="let rail of detailRailSections">
      <td *ngIf="!isDetailRailExpanded(rail.key)"><div class="skeleton-bar"></div></td>
    </ng-container>

    <td class="pd-actions-cell" *ngIf="isAdminUser()"><div class="skeleton-bar icon-skeleton"></div></td>
  </tr>
</tbody>
            <tbody *ngIf="!isLoadingTable">
              <tr *ngFor="let element of paginatedData; let rowIndex = index; trackBy: trackByRow">
                <td class="centersno">{{ rowIndex + 1 }}</td>
                <td class="fixed-col"><span class="pd-cell-text">{{ formatVesselName(element.vessel_name) }}</span></td>
                <td>{{ element.vessel_imo }}</td>
                <td>{{ element.voyage_number }}</td>
                <td *ngIf="username === 'Meraki - Operations' && subusername !== 'demo'">{{ element.client }}</td>
                <td><span class="pd-cell-text">{{ element.port || '--' }}</span></td>
                <td><span [ngStyle]="getDynamicSegmentStyle(element.segment)">{{ formatSegment(element.segment)
                    }}</span></td>

                <ng-container *ngIf="voyageDetailsSectionExpanded">
                  <td>{{ element.pic }}</td>
                  <td>{{ element.final_status }}</td>
                  <td>{{ element.operations }}</td>
                  <td>{{ formatUTCDate(element.report_sent_date) }}</td>
                </ng-container>

                <td>{{ formatPortLocalAsUTC(element.arrival_date_and_time, element.port) }}</td>
                <td>{{ formatPortLocalAsUTC(element.departure_date_and_time, element.port) }}</td>
                <td class="pd-num-cell">{{ element.cargo_quentity != null ? (element.cargo_quentity | number:'1.2-2') :
                  '--' }}</td>
                <td>{{ formatToDays(element.total_time) }}</td>
                <td class="pd-maneuvering-col">
                  <div class="pd-maneuvering-cell">
                    <span class="pd-maneuvering-cell__distance" matTooltip="Maneuvering Distance (NM)"
                      [matTooltipClass]="databaseTooltipClass">{{ formatManeuveringDistance(element) }}</span>
                    <span class="pd-maneuvering-cell__speed" matTooltip="Maneuvering Speed (kn)"
                      [matTooltipClass]="databaseTooltipClass">{{ formatManeuveringSpeed(element) }}</span>
                  </div>
                </td>

                <!-- Ops Data — always visible after Total Time -->
                <td class="pd-op-col pd-num-cell pd-group-divider">{{
                  formatMetricCell(element.actual_consumptions_mt_maneuvering_cargo_idle?.maneuvering_actual_consumption_mt)
                  }}</td>
                <td class="pd-op-col pd-num-cell">{{
                  formatMetricCell(element.actual_consumptions_mt_maneuvering_cargo_idle?.cargo_ops_actual_consumption_mt)
                  }}</td>
                <td class="pd-op-col pd-num-cell">{{
                  formatMetricCell(element.actual_consumptions_mt_maneuvering_cargo_idle?.idle_actual_consumption_mt) }}
                </td>
                <td class="pd-op-col pd-num-cell pd-group-divider" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getCpWarrantedCellTooltip(element, 'maneuvering')">
                  <div class="pd-consumption-cell">
                    <span class="pd-consumption-cell__primary">{{
                      formatMetricCell(getOpWarrantedValue(element, 'maneuvering'))
                      }}</span>
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getCpWarrantedCellView(element, 'maneuvering').differenceClass }}"
                      *ngIf="getCpWarrantedCellView(element, 'maneuvering').differenceText !== '--'">{{
                      getCpWarrantedCellView(element, 'maneuvering').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getCpWarrantedCellTooltip(element, 'cargoOps')">
                  <div class="pd-consumption-cell">
                    <span class="pd-consumption-cell__primary">{{
                      formatMetricCell(getOpWarrantedValue(element, 'cargoOps'))
                      }}</span>
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getCpWarrantedCellView(element, 'cargoOps').differenceClass }}"
                      *ngIf="getCpWarrantedCellView(element, 'cargoOps').differenceText !== '--'">{{
                      getCpWarrantedCellView(element, 'cargoOps').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getCpWarrantedCellTooltip(element, 'idle')">
                  <div class="pd-consumption-cell">
                    <span class="pd-consumption-cell__primary">{{
                      formatMetricCell(getOpWarrantedValue(element, 'idle'))
                      }}</span>
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getCpWarrantedCellView(element, 'idle').differenceClass }}"
                      *ngIf="getCpWarrantedCellView(element, 'idle').differenceText !== '--'">{{
                      getCpWarrantedCellView(element, 'idle').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell pd-group-divider" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getDesignCellTooltip(element, 'maneuvering')">
                  <div class="pd-consumption-cell">
                    <span class="pd-consumption-cell__primary">{{
                      formatMetricCell(getOpDesignValue(element, 'maneuvering'))
                      }}</span>
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getDesignCellView(element, 'maneuvering').differenceClass }}"
                      *ngIf="getDesignCellView(element, 'maneuvering').differenceText !== '--'">{{
                      getDesignCellView(element, 'maneuvering').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getDesignCellTooltip(element, 'cargoOps')">
                  <div class="pd-consumption-cell">
                    <span class="pd-consumption-cell__primary">{{
                      formatMetricCell(getOpDesignValue(element, 'cargoOps'))
                      }}</span>
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getDesignCellView(element, 'cargoOps').differenceClass }}"
                      *ngIf="getDesignCellView(element, 'cargoOps').differenceText !== '--'">{{
                      getDesignCellView(element, 'cargoOps').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getDesignCellTooltip(element, 'idle')">
                  <div class="pd-consumption-cell">
                    <span class="pd-consumption-cell__primary">{{
                      formatMetricCell(getOpDesignValue(element, 'idle'))
                      }}</span>
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getDesignCellView(element, 'idle').differenceClass }}"
                      *ngIf="getDesignCellView(element, 'idle').differenceText !== '--'">{{ getDesignCellView(element,
                      'idle').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell pd-group-divider" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getOptimizationCellTooltip(element, 'maneuvering')">
                  <div class="pd-consumption-cell">
                    <input
                      type="number"
                      class="opt-cons-input"
                      step="0.01"
                      min="0"
                      placeholder="—"
                      [ngModel]="formatOptInputValue(getOptimizationLegConsumption(element, 'maneuvering'))"
                      (ngModelChange)="setOptimizationLegConsumption(element, 'maneuvering', $event)"
                      (keydown.enter)="saveOptimizationConsumption(element, true)"
                      aria-label="Optimization Manoeuvring"
                    />
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getOptimizationCellView(element, 'maneuvering').differenceClass }}"
                      *ngIf="getOptimizationCellView(element, 'maneuvering').differenceText !== '--'">{{
                      getOptimizationCellView(element, 'maneuvering').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getOptimizationCellTooltip(element, 'cargoOps')">
                  <div class="pd-consumption-cell">
                    <input
                      type="number"
                      class="opt-cons-input"
                      step="0.01"
                      min="0"
                      placeholder="—"
                      [ngModel]="formatOptInputValue(getOptimizationLegConsumption(element, 'cargoOps'))"
                      (ngModelChange)="setOptimizationLegConsumption(element, 'cargoOps', $event)"
                      (keydown.enter)="saveOptimizationConsumption(element, true)"
                      aria-label="Optimization Cargo Ops"
                    />
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getOptimizationCellView(element, 'cargoOps').differenceClass }}"
                      *ngIf="getOptimizationCellView(element, 'cargoOps').differenceText !== '--'">{{
                      getOptimizationCellView(element, 'cargoOps').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell opt-cons-col--actions" [matTooltipClass]="databaseTooltipClass"
                  [matTooltip]="getOptimizationCellTooltip(element, 'idle')">
                  <div class="pd-consumption-cell">
                    <div class="opt-cons-cell">
                      <input
                        type="number"
                        class="opt-cons-input"
                        step="0.01"
                        min="0"
                        placeholder="—"
                        [ngModel]="formatOptInputValue(getOptimizationLegConsumption(element, 'idle'))"
                        (ngModelChange)="setOptimizationLegConsumption(element, 'idle', $event)"
                        (keydown.enter)="saveOptimizationConsumption(element, true)"
                        aria-label="Optimization Idle"
                      />
                      <button
                        type="button"
                        class="opt-cons-save-btn"
                        [disabled]="isSavingOptimizationConsumption(element) || isRowVesselMasked(element)"
                        (click)="saveOptimizationConsumption(element, true)"
                        [matTooltip]="isRowVesselMasked(element) ? 'Saving is disabled for masked vessels' : 'Save Optimization Consumption'"
                        aria-label="Save Optimization Consumption"
                      >
                        <mat-icon>{{ isSavingOptimizationConsumption(element) ? 'hourglass_top' : 'save' }}</mat-icon>
                      </button>
                    </div>
                    <span
                      class="pd-consumption-cell__diff pd-consumption-cell__diff--{{ getOptimizationCellView(element, 'idle').differenceClass }}"
                      *ngIf="getOptimizationCellView(element, 'idle').differenceText !== '--'">{{
                      getOptimizationCellView(element, 'idle').differenceText }}</span>
                  </div>
                </td>
                <td class="pd-op-col pd-num-cell pd-group-divider">{{
                  formatMetricCell(element.time_taken?.maneuvering_time_taken) }}</td>
                <td class="pd-op-col pd-num-cell">{{ formatMetricCell(element.time_taken?.cargo_ops_time_taken) }}</td>
                <td class="pd-op-col pd-num-cell">{{ formatMetricCell(element.time_taken?.idle_time_taken) }}</td>

                <td class="pd-num-cell pd-summary-col">{{ getTotalConsumption(element) }}</td>

                <ng-container *ngIf="cpExpanded">
                  <td *ngFor="let col of cpOverallDetailColumns" class="pd-fuel-col pd-num-cell pd-reveal-col"
                    [class.pd-group-divider]="isCpOverallDividerColumn(col.key)"
                    [ngStyle]="getCpLossCellColor(element, col.key) ? { color: getCpLossCellColor(element, col.key) } : null">
                    {{ formatMetricCell(getCpOverallDetailValue(element, col.key)) }}</td>
                  <td class="pd-num-cell pd-summary-col"
                    [ngStyle]="{ color: element.cp_overall_mt < 0 ? '#ff9090' : element.cp_overall_mt > 0 ? '#a8d296' : 'null' }">
                    {{ formatMetricCell(element.cp_overall_mt) }}</td>
                </ng-container>

                <ng-container *ngIf="designExpanded">
                  <td *ngFor="let col of designOverallDetailColumns" class="pd-fuel-col pd-num-cell pd-reveal-col"
                    [class.pd-group-divider]="isDesignOverallDividerColumn(col.key)"
                    [ngStyle]="getDesignLossCellColor(element, col.key) ? { color: getDesignLossCellColor(element, col.key) } : null">
                    {{ formatMetricCell(getDesignOverallDetailValue(element, col.key)) }}</td>
                  <td class="pd-num-cell pd-summary-col"
                    [ngStyle]="{ color: element.design_overall_mt < 0 ? '#ff9090' : element.design_overall_mt > 0 ? '#a8d296' : 'null' }">
                    {{ formatMetricCell(element.design_overall_mt) }}</td>
                </ng-container>

                <ng-container *ngIf="brobSectionExpanded">
                  <td class="pd-fuel-col pd-num-cell pd-group-divider pd-reveal-col">{{
                    formatMetricCell(element.brob_arrival_mt.brob_arrival_mt_hsfo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-reveal-col">{{
                    formatMetricCell(element.brob_arrival_mt.brob_arrival_mt_vlsfo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-reveal-col">{{
                    formatMetricCell(element.brob_arrival_mt.brob_arrival_mt_lsgo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-group-divider pd-reveal-col">{{
                    formatMetricCell(element.bunker_received.bunker_received_hsfo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-reveal-col">{{
                    formatMetricCell(element.bunker_received.bunker_received_vlsfo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-reveal-col">{{
                    formatMetricCell(element.bunker_received.bunker_received_lsgo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-group-divider pd-reveal-col">{{
                    formatMetricCell(element.brob_departure_mt.brob_departure_mt_hsfo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-reveal-col">{{
                    formatMetricCell(element.brob_departure_mt.brob_departure_mt_vlsfo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-reveal-col">{{
                    formatMetricCell(element.brob_departure_mt.brob_departure_mt_lsgo) }}</td>
                </ng-container>

                <ng-container *ngIf="consumptionSectionExpanded">
                  <td class="pd-summary-col pd-claim-raised-col pd-group-divider">{{ element.claim_raised }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-group-divider pd-reveal-col">{{
                    formatMetricCell(element.actual_consumptions_mt.actual_consumptions_mt_hsfo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-reveal-col">{{
                    formatMetricCell(element.actual_consumptions_mt.actual_consumptions_mt_vlsfo) }}</td>
                  <td class="pd-fuel-col pd-num-cell pd-reveal-col">{{
                    formatMetricCell(element.actual_consumptions_mt.actual_consumptions_mt_lsgo) }}</td>
                </ng-container>

                <!-- Collapse rails — summary values visible when collapsed; stay inside rail width -->
                <ng-container *ngFor="let rail of detailRailSections">
                  <td *ngIf="hasPaginatedRows && rowIndex === 0" [attr.rowspan]="paginatedData.length"
                    class="detail-rail-cell detail-rail-cell--{{ rail.cssClass }}"
                    [class.detail-rail-cell--expanded]="isDetailRailExpanded(rail.key)"
                    [class.detail-rail-cell--collapsed]="!isDetailRailExpanded(rail.key)">
                    <div class="detail-rail-body-band" *ngIf="!isDetailRailExpanded(rail.key)">
                      <span class="detail-rail-summary-line">
                        <span class="detail-rail-summary-line__text">{{ rail.fullTitle }}</span>
                        <span class="detail-rail-summary-line__sep"> • </span>
                        <span class="detail-rail-summary-line__value"
                          [ngStyle]="getDetailRailSummaryColor(rail.key) ? { color: getDetailRailSummaryColor(rail.key) } : null">
                          {{ getDetailRailSectionSummary(rail.key) }}
                        </span>
                        <span class="detail-rail-summary-line__sep"> • </span>
                        <span class="detail-rail-summary-line__unit">{{ getDetailRailSectionUnit(rail.key) }}</span>
                      </span>
                    </div>
                  </td>
                </ng-container>

                <td class="pd-actions-cell text-center" *ngIf="isAdminUser()">
                  <button mat-icon-button class="delete-icon-btn" (click)="confirmAndDeleteDatabaseRow(element, $event)"
                    aria-label="Delete database record" matTooltip="Delete">
                    <mat-icon color="warn">delete</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <mat-paginator class="premium-paginator pc-performance-paginator" [length]="filteredData?.length"
        [pageSizeOptions]="pageSizeOptions" [pageSize]="itemsPerPage" (page)="onPageChange($event)" showFirstLastButtons
        [hidePageSize]="true" [ngClass]="{ 'dark-paginator': isDarkMode() }">
      </mat-paginator>
    </div>
    <div class="text-right" *ngIf="!graph">
      <button class="btn btn-light hover-button mail" (click)="exportClick()">
        <mat-icon>download</mat-icon>&nbsp; Export
      </button>
    </div>

    <div class="graph benchmark-dashboard" *ngIf="graph">
      <div class="benchmark-stack">
        <article #pcBenchmarkSection id="benchmark-pc" class="benchmark-card benchmark-card--full">
          <div class="benchmark-card__header">
            <h3 class="benchmark-card__title">Port Consumption (PC)</h3>
            <button type="button" class="benchmark-filters-btn"
              [class.benchmark-filters-btn--active]="pcInlineFilterOpen" (click)="togglePcInlineFilters()">
              <mat-icon>filter_list</mat-icon>
              <span>PC Benchmarking</span>
            </button>
          </div>

          <div class="benchmark-toolbar">
            <span class="pc-cargo-norm-note" [attr.title]="pcCargoNormalizationLabel">
              {{ pcCargoNormalizationLabel }}
            </span>
            <div class="benchmark-toolbar__right">
              <div class="benchmark-toolbar__actions">
                <button type="button" (click)="sortConsChart('pc')" class="sort-button" matTooltip="By consumption">
                  <mat-icon class="sortIcon">swap_vert</mat-icon> Consumption
                </button>
                <button type="button" (click)="azSortChart('pc')" class="sort-button" matTooltip="A–Z">
                  <mat-icon class="sortIcon">sort_by_alpha</mat-icon> A–Z
                </button>
                <button type="button" (click)="expandMainChart()" class="sort-button">
                  <mat-icon class="sortIcon">fullscreen</mat-icon> Expand
                </button>
                <button type="button" (click)="resetPcChartDisplay()" class="sort-button clear-button">Reset</button>
              </div>
              <button type="button" class="download-link">CSV</button>
            </div>
          </div>

          <div class="graphId">
            <div *ngIf="isLoadingTcpChart" class="chart-skeleton-overlay">
          <div class="chart-skeleton-line title-sk"></div>
          <div class="chart-skeleton-bars">
            <div class="skeleton-bar chart-bar-sk" *ngFor="let _ of [1,2,3,4,5,6,7,8,9,10]"></div>
          </div>
        </div>
            <div *ngIf="chartOptions && !isLoadingPcChart" [chart]="chartOptions" class="benchmark-chart-host"></div>
            <div *ngIf="!chartOptions && !isLoadingPcChart" class="chart-no-data">
              <mat-icon>bar_chart</mat-icon>
              <span>No data</span>
              <small>Open PC Benchmarking to configure segment, operation, and ports.</small>
            </div>
          </div>
        </article>

        <article #tcpBenchmarkSection id="benchmark-tcp" class="benchmark-card benchmark-card--full">
          <div class="benchmark-card__header">
            <div class="benchmark-card__title-wrap">
              <h3 class="benchmark-card__title">TCP Benchmark</h3>
              <span class="benchmark-card__tag">Fleet</span>
              <span class="benchmark-card__tag benchmark-card__tag--count" *ngIf="tcpData?.length">{{ tcpData.length }}
                records</span>
            </div>
            <button type="button" class="benchmark-filters-btn"
              [class.benchmark-filters-btn--active]="tcpInlineFilterOpen" (click)="toggleTcpInlineFilters()">
              <mat-icon>filter_list</mat-icon>
              <span>TCP Benchmarking</span>
            </button>
          </div>

          <div class="benchmark-toolbar">
            <div class="benchmark-toolbar__actions">
              <button type="button" (click)="sortConsChart('tcp')" class="sort-button">
                <mat-icon class="sortIcon">swap_vert</mat-icon> Consumption
              </button>
              <button type="button" (click)="azSortChart('tcp')" class="sort-button">
                <mat-icon class="sortIcon">sort_by_alpha</mat-icon> A–Z
              </button>
              <button type="button" (click)="resetTcpChartDisplay()" class="sort-button clear-button">Reset</button>
            </div>
            <button type="button" class="download-link">CSV</button>
          </div>

          <div class="graphId">
            <div *ngIf="isLoadingPcChart" class="chart-skeleton-overlay">
          <div class="chart-skeleton-line title-sk"></div>
          <div class="chart-skeleton-bars">
            <div class="skeleton-bar chart-bar-sk" *ngFor="let _ of [1,2,3,4,5,6,7,8,9,10]"></div>
          </div>
        </div>
            <div *ngIf="tcpChartOptions && !isLoadingTcpChart" [chart]="tcpChartOptions" class="benchmark-chart-host">
            </div>
            <div *ngIf="!tcpChartOptions && !isLoadingTcpChart" class="chart-no-data">
              <mat-icon>bar_chart</mat-icon>
              <span>No data</span>
              <small>Open TCP Benchmarking to configure TCP benchmark criteria.</small>
            </div>
          </div>
        </article>
      </div>

      <div class="benchmark-filter-overlay" *ngIf="pcInlineFilterOpen || tcpInlineFilterOpen"
        (click)="closeBenchmarkFilterDrawers()"></div>

      <aside class="benchmark-filter-drawer" [class.open]="pcInlineFilterOpen" [formGroup]="pcBenchmarkForm"
        (click)="$event.stopPropagation()">
        <div class="benchmark-filter-drawer__header">
          <h4>PC Benchmarking</h4>
          <button type="button" class="benchmark-filter-drawer__close" (click)="closePcFilterDrawer()"
            aria-label="Close PC Benchmarking">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="benchmark-filter-drawer__body">
          <div class="filter-field filter-field--multi" *ngIf="subusername !== 'demo'">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Client" placeholder="All" allLabel="All"
              [options]="pcClientOptions" [selected]="selectedPcClients" (selectedChange)="onPcClientsChanged($event)"
              (dropdownClosed)="onPcClientSelectionChange()">
            </app-pc-multi-select-filter>
          </div>

          <div class="filter-field">
            <label class="filter-field__label">Segment</label>
            <div class="bench-select-wrap">
              <select class="bench-control bench-control--select" [(ngModel)]="selectedPcSegment"
                [ngModelOptions]="{standalone: true}" [compareWith]="pcSegmentOptionCompare"
                (change)="onSegmentPcChange()">
                <option *ngFor="let segment of pcSegments" [ngValue]="segment.key">{{ segment.key }}</option>
              </select>
            </div>
          </div>

          <div class="filter-field">
            <label class="filter-field__label">Operations</label>
            <div class="bench-select-wrap">
              <select class="bench-control bench-control--select" [(ngModel)]="selectedPcOperation"
                [ngModelOptions]="{standalone: true}" (change)="onOperationChange()">
                <option *ngFor="let op of operationsOptions" [value]="op">{{ op }}</option>
              </select>
            </div>
          </div>

          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Port" placeholder="All" allLabel="All"
              searchPlaceholder="Search ports..." [options]="pcPortOptions" [selected]="selectedPorts"
              (selectedChange)="onPcPortsChanged($event)" (dropdownClosed)="onPcPortSelectionChange()">
            </app-pc-multi-select-filter>
          </div>

          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Vessel Name" placeholder="All" allLabel="All"
              [options]="pcVesselNameOptions" [selected]="selectedVessels" (selectedChange)="onPcVesselsChanged($event)"
              (dropdownClosed)="onPcVesselSelectionChange()">
            </app-pc-multi-select-filter>
          </div>

          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Yard" placeholder="All" allLabel="All"
              [options]="pcYardOptions" [selected]="selectedPcYards" (selectedChange)="onPcYardsChanged($event)">
            </app-pc-multi-select-filter>
          </div>

          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Built Year (Age)" placeholder="All"
              allLabel="All" emptyMessage="No build years available" searchPlaceholder="Search age..."
              [optionItems]="pcBuiltAgeOptionItems" [selected]="selectedPcBuiltAges"
              (selectedChange)="onPcBuiltAgesChanged($event)">
            </app-pc-multi-select-filter>
          </div>

          <!-- Ship Built date filters — temporarily disabled
        <div class="filter-field">
          <label class="filter-field__label" for="pc-ship-built-from">Ship Built From</label>
          <input id="pc-ship-built-from" type="date" class="bench-control bench-control--date" formControlName="ship_built_from"
            [min]="pcBuiltDateMin"
            [max]="pcBenchmarkForm.get('ship_built_to')?.value || pcBuiltDateMax" />
        </div>

        <div class="filter-field">
          <label class="filter-field__label" for="pc-ship-built-to">Ship Built To</label>
          <input id="pc-ship-built-to" type="date" class="bench-control bench-control--date" formControlName="ship_built_to"
            [min]="pcBenchmarkForm.get('ship_built_from')?.value || pcBuiltDateMin"
            [max]="pcBuiltDateMax" />
        </div>
        -->
        </div>

        <div class="benchmark-filter-drawer__footer">
          <button type="button" class="benchmark-filter-drawer__btn benchmark-filter-drawer__btn--ghost"
            (click)="clearPcBenchmarkFilters()">Clear All</button>
          <button type="button" class="benchmark-filter-drawer__btn benchmark-filter-drawer__btn--primary"
            (click)="applyPcBenchmarkFilters()">Apply</button>
        </div>
      </aside>

      <aside class="benchmark-filter-drawer benchmark-filter-drawer--tcp" [class.open]="tcpInlineFilterOpen"
        (click)="$event.stopPropagation()">
        <div class="benchmark-filter-drawer__header">
          <h4>TCP Benchmarking</h4>
          <button type="button" class="benchmark-filter-drawer__close" (click)="closeTcpFilterDrawer()"
            aria-label="Close TCP Benchmarking">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="benchmark-filter-drawer__body">
          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Client" placeholder="All" allLabel="All"
              [options]="tcpClientOptions" [selected]="selectedTcpClients"
              (selectedChange)="onTcpClientsChanged($event)" (dropdownClosed)="onTcpClientSelectionChange()">
            </app-pc-multi-select-filter>
          </div>

          <div class="filter-field">
            <label class="filter-field__label">Segment</label>
            <div class="bench-select-wrap">
              <select class="bench-control bench-control--select" [(ngModel)]="selectedSegment"
                [ngModelOptions]="{standalone: true}" [compareWith]="pcSegmentOptionCompare"
                (change)="onTcpSegmentChange()">
                <option *ngFor="let segment of benchmarkSegments" [ngValue]="segment.key">{{ segment.key }}</option>
              </select>
            </div>
          </div>

          <div class="filter-field">
            <label class="filter-field__label">Operations</label>
            <div class="bench-select-wrap">
              <select class="bench-control bench-control--select" [(ngModel)]="selectedOperation"
                [ngModelOptions]="{standalone: true}" (change)="onTcpOperationChange()">
                <option *ngFor="let operation of tcpOperationOptions" [value]="operation">{{ operation }}</option>
              </select>
            </div>
          </div>

          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Port" placeholder="All" allLabel="All"
              searchPlaceholder="Search ports..." [options]="tcpPortOptions" [selected]="selectedTcpPorts"
              (selectedChange)="onTcpPortsChanged($event)" (dropdownClosed)="onTcpPortSelectionChange()">
            </app-pc-multi-select-filter>
          </div>

          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Vessel Name" placeholder="All" allLabel="All"
              [options]="tcpVesselNameOptions" [selected]="selectedTcpVesselNames"
              (selectedChange)="onTcpVesselsChanged($event)" (dropdownClosed)="onTcpVesselSelectionChange()">
            </app-pc-multi-select-filter>
          </div>

          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Yard Name" placeholder="All" allLabel="All"
              [options]="tcpYardOptions" [selected]="selectedTcpYards" (selectedChange)="onTcpYardsChanged($event)"
              (dropdownClosed)="onTcpBenchmarkFilterChange()">
            </app-pc-multi-select-filter>
          </div>

          <div class="filter-field filter-field--multi">
            <app-pc-multi-select-filter [lightMode]="!isDarkMode()" label="Built Year (Age)" placeholder="All"
              allLabel="All" emptyMessage="No build years available" searchPlaceholder="Search age..."
              [optionItems]="tcpBuiltAgeOptionItems" [selected]="selectedTcpBuiltAges"
              (selectedChange)="onTcpBuiltAgesChanged($event)">
            </app-pc-multi-select-filter>
          </div>
        </div>

        <div class="benchmark-filter-drawer__footer">
          <button type="button" class="benchmark-filter-drawer__btn benchmark-filter-drawer__btn--ghost"
            (click)="clearAllTcpBenchmarkFilters()">Clear All</button>
          <button type="button" class="benchmark-filter-drawer__btn benchmark-filter-drawer__btn--primary"
            (click)="applyTcpBenchmarkFilters()">Apply</button>
        </div>
      </aside>
    </div>
  </div>
</div>